import { PayloadAction } from '@reduxjs/toolkit'
import { call, put, takeLatest } from 'redux-saga/effects'
import * as bulkOperationsActions from '../actions/bulkOperationsActions'
import * as global from '../actions/globalActions'
import { BulkRefinalizeRequest } from '../api/refinalize'
import { ApiServiceInstance } from '../services/ApiService'
import { Errors } from '../services/ErrorMessageService'

function* bulkRefinalize(action: PayloadAction<BulkRefinalizeRequest>) {
  try {
    yield put(global.showSpinner())
    const response = yield call(ApiServiceInstance.post, 'documentretrievals/bulkRefinalize', action.payload)

    yield put(
      bulkOperationsActions.bulkRefinalizeReceived({
        response: response.data,
        valid: true,
      })
    )
  } catch (e) {
    yield put(Errors.toErrorAction(e))
  } finally {
    yield put(global.hideSpinner())
  }
}

export default function* root() {
  yield takeLatest(bulkOperationsActions.bulkRefinalizeRequest, bulkRefinalize)
}
